import type { EnvironmentContextType } from './src/app/utils/environmentContext';

const ubikContextEnvProduction: EnvironmentContextType = {
    ENV_TRACKING_ENV: 'prod',
    ENV_LOGOMATION_BASE_URL: 'https://prod-logomation-service.algo.design.vpsvc.com',
    ENV_API_BASE_URL: 'https://new-business-growth-api.prod.new-business-growth.vpsvc.com',
    // This URL required as Vista Logos' branch environments do not share same origin as Logomaker Experience
    ENV_LOGOMAKER_BASE_URL: '/logomaker',
    ENV_PRODUCT_SERVICE_BASE_URL:
        'https://merchant-orchestration-api.products.cimpress.io/v3/products',
    ENV_DOMAIN_SEARCH_URL: 'https://partners.vpsvc.com/api/anonymous/v1/domain/search',
};

export { ubikContextEnvProduction };
